<template>
    <div class="full-screen">
        <header class="header-wrapper">
            <div class="header-box">
                <div class="container">
                    <div class="row">
                        <div class="col">
                            <header-nav></header-nav>
                        </div>
                    </div>
                </div>
            </div>
        </header><!-- End Header -->
        <div class="main">
            <div class="header-background"></div>
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-8">
                        <div class="content-box">
                            <div class="content-header">
                                <h1 class="content-title" v-html="currentPage.title"></h1>
                                <span class="content-subtitle" v-html="currentPage.subtitle"></span>
                            </div>
                            <!-- Form -->
                            <div class="form-wrapper">
                                <router-view/>
                            </div>
                            <!-- End Form -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <footer-component></footer-component>
    </div>
</template>

<script>
    export default {
        name: 'authentication',

        data() {
            return {}
        },

        computed: {
            currentPage() {
                if (this.$route.name === 'login' || this.$route.name === 'AdminAuth') {
                    let info = {
                        title: this.$t('authorization.login.title'),
                        subtitle: this.$t('authorization.login.subtitle')
                    }
                    return info
                }
                if (this.$route.name === 'register') {
                    let info = {
                        title: this.$t('authorization.register.title'),
                        subtitle: this.$t('authorization.register.subtitle')
                    }
                    return info
                }
                if (this.$route.name === 'ForgotPassword' || this.$route.name === 'NewPassword') {
                    let info = {
                        title: this.$t('authorization.reset_password.title'),
                        subtitle: this.$t('authorization.reset_password.title')
                    }
                    return info
                }
            }
        }
    }
</script>

<style lang="scss">
    $img-path: '~img';

    .main {
        .content-box {
            .content-header {
                padding-bottom: 49px;
            }
            .content-title,
            .content-subtitle {
                color: white;
            }
        }
        .form-container-header {
            .form-title {
                padding-bottom: 30px;
            }
        }
    }

    .header-background {
        background-image: url("#{$img-path}/bg-registration.jpg");
    }
</style>



// WEBPACK FOOTER //
// src/components/Authentication/Authentication.vue